/**
 * Create Classes context for custom hook
 */

import { createContext } from 'react'

const ClassesContext = createContext({
  fetchClasses: () => {},
  fetchClassesAll: () => {}
})

export default ClassesContext
